if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe === 'function') {
          this._unsubscribe = subscribe('variant-change', (event) => {
            const html = event && event.data && event.data.html;
            const mediaId = event && event.data && event.data.variant &&
              event.data.variant.featured_media && event.data.variant.featured_media.id;
            if (html) {
              this._updateFromHtml(html, mediaId ? String(mediaId) : null);
            } else if (mediaId) {
              this._slideTo(String(mediaId));
            }
          });
        }
      }

      disconnectedCallback() {
        if (this._unsubscribe) this._unsubscribe();
      }

      // Called by product-info.js
      setActiveMedia(mediaId) {
        const str = String(mediaId);
        this._slideTo(str.includes('-') ? str.split('-').pop() : str);
      }

      _realSlides() {
        return Array.from(this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
      }

      _updateFromHtml(html, activeMediaId) {
        // If the target slide already exists in the gallery, just navigate
        if (activeMediaId) {
          const found = this._realSlides().some((slide) => {
            const el = slide.querySelector('[data-media-id]');
            return el && String(el.dataset.mediaId) === activeMediaId;
          });
          if (found) {
            this._slideTo(activeMediaId);
            return;
          }
        }

        // Target slide is missing — swap in the new gallery slides from fetched HTML
        const newWrapper = html.querySelector('media-gallery .swiper-wrapper');
        const currentWrapper = this.querySelector('.swiper-wrapper');
        if (!newWrapper || !currentWrapper) return;

        const swiperComponent = this.querySelector('swiper-component');

        // Tear down existing swiper cleanly
        if (swiperComponent) {
          if (swiperComponent.breakpoint && swiperComponent.breakpointChecker) {
            swiperComponent.breakpoint.removeEventListener('change', swiperComponent.breakpointChecker);
          }
          if (swiperComponent.initSwiper) {
            swiperComponent.initSwiper.destroy(true, true);
            swiperComponent.initSwiper = null;
          }
          if (swiperComponent.swiperEl) {
            swiperComponent.swiperEl._swiperInitialized = false;
          }
          swiperComponent._items = null;
        }

        // Swap slide content
        currentWrapper.innerHTML = newWrapper.innerHTML;

        // Re-initialise swiper
        if (swiperComponent) {
          swiperComponent.initializeSwiper();
        }

        // The zoom dialog was rendered with the old (filtered) media set;
        // sync its lists from the same fetched HTML so zoom-by-index stays
        // aligned with the new slides.
        this._syncZoomDialog(html);
      }

      _syncZoomDialog(html) {
        const liveZoom = this.querySelector('zoom-dialog');
        if (!liveZoom) return;
        const newZoom = html.querySelector(`zoom-dialog[id="${liveZoom.id}"]`) ||
          html.querySelector('media-gallery zoom-dialog');
        if (!newZoom) return;
        ['.dialog-zoomed-gallery', '.dialog-thumbnails-list'].forEach((sel) => {
          const liveList = liveZoom.querySelector(sel);
          const newList = newZoom.querySelector(sel);
          if (liveList && newList) liveList.innerHTML = newList.innerHTML;
        });
        if (typeof liveZoom.refresh === 'function') liveZoom.refresh();
      }

      _slideTo(mediaId) {
        const strId = String(mediaId);
        const slides = this._realSlides();
        const targetIndex = slides.findIndex((slide) => {
          const el = slide.querySelector('[data-media-id]');
          if (!el) return false;
          const id = String(el.dataset.mediaId);
          return id === strId || id.endsWith('-' + strId);
        });
        if (targetIndex === -1) return;

        const swiperComponent = this.querySelector('swiper-component');
        const navigate = (sc) => {
          const swiper = sc.initSwiper;
          if (!swiper) return;
          if (swiper.params && swiper.params.loop) {
            swiper.slideToLoop(targetIndex, 300);
          } else {
            swiper.slideTo(targetIndex, 300);
          }
        };

        if (swiperComponent && swiperComponent.initSwiper) {
          navigate(swiperComponent);
        } else if (swiperComponent) {
          const start = Date.now();
          const retry = setInterval(() => {
            if (swiperComponent.initSwiper) {
              navigate(swiperComponent);
              clearInterval(retry);
            } else if (Date.now() - start > 1000) {
              clearInterval(retry);
            }
          }, 50);
        }
      }
    }
  );
}
